import React from "react";
import { cn } from "../../lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { ITheme } from "../../lib/types";
import { themes } from "../../lib/consts";

interface ThemeSelectProps {
    theme?: ITheme;
    onChange: (value: ITheme | undefined) => void;
}
export default function ThemeSelect({ theme, onChange }: ThemeSelectProps) {
    return (
        <Select defaultValue={theme?.name || "Slate"} onValueChange={(t) => onChange(themes.find((tw) => tw.name === t))}>
            <SelectTrigger className="w-full]">
                <SelectValue placeholder="Theme" />
            </SelectTrigger>
            <SelectContent className="max-h-56">
                {themes.map((theme) => (
                    <SelectItem value={theme.name}>
                        <div className="flex items-center gap-2">
                            <div className={cn(theme.background, theme.foreground, "flex h-8 w-8 items-center justify-center rounded-lg font-medium")}>T</div>
                            {theme.name}
                        </div>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
